module.exports = __webpack_public_path__ + "353f8e647a29592d02b34a69f426b1c6.svg";